import { generalEnv } from '@nx-frontend/shared/env';

interface GetOrgDashboardUrlProps {
  orgId: string;
  spaceId?: string;
  sub?: string;
  domain?: string;
  query?: string;
}

export const getOrgDashboardUrl = ({ orgId, spaceId, sub, domain, query }: GetOrgDashboardUrlProps) => {
  let url =
    domain != null
      ? `https://${domain}`
      : sub != null && generalEnv.nimbusDomain !== 'localhost'
      ? `https://${sub}.${generalEnv.nimbusDomain}`
      : '';

  url += `/dashboard/${orgId}`;

  if (spaceId != null) {
    url += `/space/${spaceId}`;
  }

  const preparedQuery = query && query.length ? `?${query}` : '';

  return `${url}${preparedQuery}`;
};
